module.exports = __webpack_public_path__ + "img/vi.8a0beafd.svg";